import CircleCheckIcon from '@svg/circle-check.svg';
import React from 'react';
import styled from 'styled-components';
import { Chip } from '../../Chip';

const StyledActiveChip = styled(Chip)`
  height: 2rem;
  padding: 0.5rem;

  svg {
    width: 1rem;
    height: 1rem;
    margin-right: 2px;
    fill: ${({ theme }) => theme.colors.green};
  }
`;

export function AnalyticsSyncActiveChip({ className }: { className?: string }) {
  return (
    <StyledActiveChip
      color="primary"
      label="Sync active"
      icon={<CircleCheckIcon />}
      className={className}
    />
  );
}
